import { Component, Input, OnInit } from '@angular/core';
import { KamonaMessageWidgetComponent } from '../../kamona-message-widget.component';
import { ModalType } from '../../../../model/kamonal-model';

@Component({
    selector: 'app-mobile-kamona-message-widget',
    templateUrl: './mobile-kamona-message-widget.component.html',
    styleUrls: ['./mobile-kamona-message-widget.component.scss'],
})
export class MobileKamonaMessageWidgetComponent extends KamonaMessageWidgetComponent implements OnInit {
    wrapperClass: any;
    @Input() isFullScreen = false;
    @Input() useDefaultBackground = false;
    @Input() useDefaultDialogBackdrop = false;
    constructor() {
        super();
    }

    ngOnInit(): void {
        this.setWrapperClass();
        this.showModal();
        this.initialize();
    }

    setWrapperClass() {
        if (this.useDefaultBackground && this.useDefaultDialogBackdrop) {
            this.wrapperClass = {
                'default-mobile-backdrop': true,
            };
            return;
        }

        if (this.useDefaultBackground) {
            this.wrapperClass = {
                'default-mobile-modal': true,
            };
            return;
        }
        this.wrapperClass = {
            'default-mobile-modal': this.modalType === ModalType.DEFAULT,
            'custom-mobile-modal': this.modalType === ModalType.CUSTOM,
        };
    }

    getModal() {
        return document.querySelector('[id-mobile-message-modal]');
    }
}
